import React from 'react';
import { useTranslation } from 'react-i18next';
import { getHomeFaqItems } from '../data/homeFaq';
import { getLocaleFromPathname } from '../config/localeRoutes';
import { useLocation } from 'react-router-dom';
import './HomeFaq.css';

function HomeFaq() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname) || (i18n.language?.startsWith('en') ? 'en' : 'fr');
  const faqItems = getHomeFaqItems(locale);

  return (
    <section id="faq" className="home-faq section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('homeFaq.title')}</h2>
        </div>

        <div className="home-faq-list">
          {faqItems.map((item) => (
            <details key={item.question} className="home-faq-item">
              <summary className="home-faq-question">{item.question}</summary>
              <p className="home-faq-answer">{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeFaq;
